import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TipoPagamentoInserirComponent } from './tipo-pagamento-inserir.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: TipoPagamentoInserirComponent }
    ])],
    exports: [RouterModule]
})
export class TipoPagamentoInserirRoutingModule { }
